import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/wallets";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u06a9\u06cc\u0641 \u067e\u0648\u0644";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getWallet() {
  return request("/wallet/");
}

export function getAddresses() {
  return request("/wallet/addresses/");
}

export function getTransactions() {
  return request("/wallet/transactions/");
}

export function createAddress(address) {
  return request("/wallet/addresses/", {
    method: "POST",
    body: JSON.stringify({ address }),
  });
}

export function verifyAddress(address_id, verification_code) {
  return request("/wallet/addresses/verify/", {
    method: "PUT",
    body: JSON.stringify({ address_id, verification_code }),
  });
}
